import AsyncStorage from "@react-native-async-storage/async-storage";
import { StoreKey } from "../../configs/api";
import { ROUTE } from "../../routes";
export const closePopup = async (action, _datastore, { goBack, navigateToBase, navigate }) => {
    const routeId = await AsyncStorage.getItem(StoreKey.ROUTE_ID);
    const fromInProgressProcess = action?.payload?.fromInProgressProcess;
    const amountToPay = action?.payload?.amountToPay;
    const isFromDashboard = action?.payload?.isFromDashboard;
    switch (routeId) {
        case ROUTE.DIGIO_MANDATE_SIGN:
            await navigateToBase(ROUTE.DIGIO_MANDATE_SIGN, {
                showExtraMandateError: false,
                mandateErrorData: undefined
            });
            break;
        case ROUTE.FORECLOSURE:
            if (fromInProgressProcess) {
                await navigate(ROUTE.FORECLOSURE, {
                    fromInProgressProcess: true
                });
            }
            else {
                await navigate(ROUTE.FORECLOSURE);
            }
            break;
        case ROUTE.PAYMENT_START:
            await navigate(ROUTE.PAYMENT_START, {
                fromNeedHelp: true,
                amountToPay: amountToPay,
                isFromDashboard: isFromDashboard
            });
            break;
        default:
            await goBack();
    }
};
